import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles, Star } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SisterBrandSection = () => {
  const navigate = useNavigate();

  return (
    <section className="section-spacing bg-gradient-to-br from-primary/10 via-accent/15 to-secondary/10 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-96 h-96 bg-accent/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 bg-primary/20 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        {/* Badge */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm">
            <Star className="w-4 h-4 accent-gold" />
            <span className="text-sm font-sans font-medium text-foreground tracking-wider">DISCOVER OUR SISTER BRAND</span>
          </div>
        </div>

        {/* Main content */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left side - Brand highlight */}
          <div className="bg-white rounded-2xl p-10 shadow-xl card-hover">
            <div className="mb-6">
              <h2 className="text-4xl sm:text-5xl font-serif font-semibold text-foreground mb-4">
                Waisted Bunny
              </h2>
              <div className="w-16 h-1 bg-accent-gold rounded-full"></div>
            </div>
            
            <p className="text-lg text-muted-foreground font-sans leading-relaxed mb-6">
              Where confidence meets cutting-edge style. Waisted Bunny brings you fashion-forward shapewear and waist trainers designed for the modern, trend-conscious woman who refuses to compromise on style or comfort.
            </p>

            <div className="space-y-3 mb-8">
              <div className="flex items-start gap-3">
                <Sparkles className="w-5 h-5 accent-gold flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-sans font-semibold text-foreground mb-1">Fashion-Forward Designs</h4>
                  <p className="text-sm text-muted-foreground">Bold prints, vibrant colors, and trend-driven pieces</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Sparkles className="w-5 h-5 accent-gold flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-sans font-semibold text-foreground mb-1">Stylish Confidence</h4>
                  <p className="text-sm text-muted-foreground">Look and feel amazing in every outfit</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Sparkles className="w-5 h-5 accent-gold flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-sans font-semibold text-foreground mb-1">Trendsetting Appeal</h4>
                  <p className="text-sm text-muted-foreground">For the woman who loves to make a statement</p>
                </div>
              </div>
            </div>

            <Button 
              size="lg" 
              className="bg-accent-gold hover:bg-accent-gold/90 text-white font-sans font-bold text-sm tracking-wider px-8 py-6 rounded-lg shadow-lg hover-lift group w-full sm:w-auto"
              onClick={() => navigate('/waisted-bunny')}
            >
              Explore Waisted Bunny
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          {/* Right side - Visual appeal */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-serif font-semibold text-foreground mb-4">
                Two Brands, One Mission
              </h3>
              <p className="text-base text-muted-foreground font-sans leading-relaxed mb-4">
                Whether you're drawn to the empowering, body-positive philosophy of <span className="font-semibold text-foreground">Waisted Momma</span> or the bold, fashion-forward energy of <span className="font-semibold text-foreground">Waisted Bunny</span>, we're here to support your confidence journey.
              </p>
              <p className="text-base text-foreground font-sans font-semibold">
                Same premium quality. Same commitment to your confidence. Different vibes.
              </p>
            </div>

            <div className="bg-blush rounded-2xl p-8 shadow-md">
              <div className="flex items-center gap-4 mb-4">
                <div className="p-3 bg-white rounded-full shadow-sm">
                  <Star className="w-6 h-6 accent-gold fill-accent-gold" />
                </div>
                <div>
                  <p className="text-lg font-serif font-semibold text-foreground">Perfect For</p>
                </div>
              </div>
              <ul className="space-y-2 text-sm font-sans text-muted-foreground">
                <li className="flex items-start gap-2">
                  <span className="text-accent-gold">✓</span>
                  <span>Women who love bold, trendy fashion</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-accent-gold">✓</span>
                  <span>Those seeking statement-making shapewear</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-accent-gold">✓</span>
                  <span>Anyone who wants style without sacrifice</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SisterBrandSection;
